
/** Messenger dummy data */

export const users = [
    {
      id:1,
      name:'Jonathan Carter', 
      avatar:'/images/avatars/Vector-1.png',
      date:'18:20',
      message:'Do you have any vaction plan',
      readed_at: true,
      pinned:true,
      group: true,
    },
    {
      id:2,
      name:'AI Art', 
      avatar:'/images/avatars/Vector-2.png',
      date:'18:20',
      message:'You might miss this last week',
      pinned:true,
    },
    {
      id:4,
      name:'Evan Lee', 
      avatar:'/images/avatars/Vector-3.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
      count:1,
    },
    {
      id:5,
      name:'Designers', 
      avatar:'/images/avatars/Vector-4.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
    },
    {
      id:6,
      name:'Allan East', 
      avatar:'/images/avatars/Vector-5.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
      group: true,
      typing: true,
    },
    {
      id:7,
      name:'Johnnie Vicente', 
      avatar:'/images/avatars/Vector-6.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
    },
    {
      id:8,
      name:'Penelope Cruz', 
      avatar:'/images/avatars/Vector-7.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
      sound: true,
      count:3,
    },
    {
      id:9,
      name:'Marty Green', 
      avatar:'/images/avatars/Vector-8.png',
      date:'18:20',
      message:'You might miss this last week',
      readed_at: true,
      group: true,
      count:7,
    },
    {
      id:10,
      name:'Cedric Woods', 
      avatar:'/images/avatars/Vector-9.png',
      date:'18:20',
      message:'Do you have any vaction plan',
      readed_at: true,
      group: true,
      count:9,
    },
    {
      id:11,
      name:'Caesar Juan', 
      avatar:'/images/avatars/Vector-10.png',
      date:'18:20',
      message:'Do you have any vaction plan',
      readed_at: true,
      group: true,
    },
    {
      id:12,
      name:'Upstream.Design', 
      avatar:'/images/avatars/Vector-11.png',
      date:'18:20',
      message:'Do you have any vaction plan',
      sound: true,
    }, 

]

/** Neon dummy data */

export const neonUsers = [
  {
    id:1,
    name:'Design Team', 
    date:'3h',
    message:'Are Mike called you',
    readed_at: false,
    unread:14,
    group: true,
    type:3,
    members:[
      '/images/avatars/Vector-3.png',
      '/images/avatars/Vector-4.png',
    ],
    count:9,
    color:'#ff5757',
  }, 
  {
    id:2,
    name:'Product Review', 
    date:'5h',
    message:'Look at this app',
    unnotified:true,
    typing: true,
    readed_at: false,
    unread:7,
    group: true,
    type:1,
    members:[
      '/images/avatars/Vector-2.png',
    ],
    count:5,
    color:'#34a853',
  },  
  {
    id:3,
    name:'Dawood Zaed', 
    date:'8h',
    message:'Sure it\'s wonderfull',
    readed_at: false,
    unread:5,
    count:3,
    color:'#fdad00',
  },
  {
    id:4,
    name:'Omar Faruk', 
    date:'1d',
    message:'Look at this app',
    readed_at: true,
    members:[
      '/images/avatars/Vector-1.png',
    ],
  },
  {
    id:5,
    name:'Alexandra', 
    date:'1w',
    message:'Look at this app',
    readed_at: true,
    unread:3,
    type:2,
    group: true,
    muted: true,
    members:[
      '/images/avatars/Vector-5.png',
      '/images/avatars/Vector-6.png',
    ],
  },  
  {
    id:6,
    name:'Stakeholders', 
    date:'3w',
    message:'Waiting for another meet',
    readed_at: true,
    group: true,
    type:4,
    members:[
      '/images/avatars/Vector-7.png',
      '/images/avatars/Vector-8.png',
      '/images/avatars/Vector-9.png',
    ],
  }, 
  {
    id:7,
    name:'Dexter Martin', 
    date:'1m',
    message:'Just looking out with Capt',
    readed_at: true,
    members:[
      '/images/avatars/Vector-7.png',
    ],
  }, 
  {
    id:8,
    name:'Lex Luthor', 
    date:'1m',
    message:'Added more notes to he',
    readed_at: true,
    members:[
      '/images/avatars/Vector-8.png',
    ],
  }, 
  {
    id:8,
    name:'Johnny M. White', 
    date:'1m',
    message:'Ok, see you later ha',
    readed_at: true,
    members:[
      '/images/avatars/Vector-10.png',
    ],
  }, 
]

export const neonUserGroups = [
  {name:'INVESTORS', list:[
    { id:1, foreground:'#9757b2', name:'Taylor', description:'Designing', bot:true, type:'online', letter:'Z', color:'#ac22dc', },
    { id:2, foreground:'#1ab698', name:'Jose Wright', type:'busy', letter:'F', color:'#f65385',  },
  ]},

  {name:'CONTRIBUTERS', list:[
    { id:3, foreground:'#9757b2', name:'Charlie', type:'busy', letter:'D', color:'#00b060', },
    { id:4, foreground:'#e48029', name:'Ryan Clark', description:'cap', type:'offline', letter:'G', color:'#f8c717', },
    { id:5, foreground:'#e36263', name:'Janet👑', type:'offline', letter:'H', color:'#92999f', },
  ]},

  {name:'ENTREPRENEURS', list:[
    { id:6, foreground:'#ca8a04', name:'Samuel Scott', type:'busy', letter:'F', color:'#f65385',  },
  ]},

  {name:'DESIGNERS', list:[
    { id:7, foreground:'#1bcbcf', name:'Catherine Dave', type:'afk', letter:'O', color:'#00e676',  },
  ]},
  

]

/** Team dummy data */

export const teamUserGroups = [
  {name:'MEMBERS', size:22, list:[
    { id:1, foreground:'#9757b2', name:'Justin', description:'programming game', bot:true, type:'offline', letter:'3', color:'#ff3030', },
    { id:2, foreground:'#1ab698', name:'Bobby', type:'online', letter:'F', color:'#f65385',  },
    { id:3, foreground:'#9757b2', name:'Cleric', type:'busy', color:'#d1d5db', },
  ]},

  {name:'DEVELOPERS', size:17, list:[
    { id:4, foreground:'#9757b2', name:'Spark', description:'app | ?help developing', bot:true, type:'online', letter:'3', color:'#ff3030', },
    { id:5, foreground:'#1ab698', name:'Jamie CLanc', type:'busy', letter:'F', color:'#f65385',  },

  ]},

  {name:'ENTREPRENEURS', size:45, list:[
    { id:6, foreground:'#9757b2', name:'Valkyrie', type:'busy', letter:'D', color:'#00b060', },
    { id:7, foreground:'#e48029', name:'jamsql', description:'cap', type:'online', letter:'G', color:'#f8c717', },
    { id:8, foreground:'#e36263', name:'Jeanine👑', type:'offline', letter:'H', color:'#92999f', },
  ]},

  {name:'CONTRIBUTORS', size:79, list:[
    { id:9, foreground:'#1bcbcf', name:'Sodium', type:'afk', letter:'O', color:'#00e676',  },
  ]},

] 

export const teamChannels = [
  {name:'EXTRA CHARTS', type:'text', list:[
    { id:1, name:'general' },
    { id:2, name:'gaming' },
    { id:3, name:'programming ✨' },
    { id:4, name:'design' },
    { id:5, name:'meetup' },
    { id:6, name:'announcements' },
  ]},
  {name:'VOICE CHANNELS', type:'voice', list:[
    { id:7, name:'Technical', active:true, children:[
      {id:101, avatar:'/images/avatars/Vector-10.png', name:'Jeff', video:true },
      {id:102, avatar:'/images/avatars/Vector-12.png', name:'Joe', video:true },
      {id:103, avatar:'/images/avatars/Vector-11.png', name:'Allan', },
    ] },
    { id:8, name:'Soundproof - AFK'},
    { id:9, name:'Lounge'},
    { id:10, name:'Mic Check'},
    { id:11, name:'Deep Studio'},
    { id:12, name:'Sound Office'},
    { id:13, name:'D.J.'},
    { id:14, name:'Study Room 1', duration:'00/04' },
    { id:15, name:'Study Room 2'},
    { id:16, name:'25/7 Radio'},
  ]},
]

/** Support dummy data */

export const supportGroups = [
  {id:1, title:'Realm - Directory Wordpress Theme', brand:'wordpress'},
  {id:2, title:'MonoCube - Finance Web Template with Angular', brand:'angular'},
  {id:3, title:'Finance & Economy Aesthetic React Template ', brand:'react', count:1},
  {id:4, title:'Cognitive | Multipurpose Shopify E-commerce Web Template', brand:'shopify'},
  {id:5, title:'Reef Business And Multipurpose Responsive HTML Website Template', brand:'tailwind', count:7},
  {id:6, title:'Blue While Construction Laravel Template', brand:'laravel', count:3},
  {id:7, title:'Archery - Architecture & Interior Design NextJS Template', brand:'next'},
  {id:8, title:'Bliss Digital Marketing Agency Website ', brand:'strapi'},
  {id:9, title:'Megæ - Admin Dashboard Theme with VueJS', brand:'vue'},
  {id:10, title:'King - IT&T Software & Technology Figma UI', brand:'figma', count:9},
  {id:11, title:'Bee | Responsive Multipurpose WordPress & WooCommerce Theme', brand:'woocommerce'},
  {id:12, title:'Lands Booking & Directory WooCommerce Theme', brand:'woocommerce'},
  {id:13, title:'RealHouses | Real Estate Wordpress Theme', brand:'wordpress'},
  {id:14, title:'Ecco Ecology & Solar Energy WordPress Theme', brand:'wordpress', count:5},
  {id:15, title:'King | Clean Multipurpose Shopify Theme', brand:'shopify', count:8},
  {id:16, title:'Bliss | Modern Multi-Purpose HTML5 Template', brand:'html'},
] 